"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var CmsElements_1 = require("@wix/dealer-core/dist/src/components/CmsElements/CmsElements");
var src_1 = require("@wix/dealer-store/dist/src");
var Root = /** @class */ (function (_super) {
    tslib_1.__extends(Root, _super);
    function Root() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.reportError = function (errorObj) {
            src_1.reportError(tslib_1.__assign({ errorType: 'JSON' }, errorObj), _this.props.cmsDataStore.getBannerPosition(), _this.props.onError);
        };
        return _this;
    }
    Root.prototype.render = function () {
        var _a = this.props, cmsDataStore = _a.cmsDataStore, loaded = _a.loaded, dealerOptions = _a.dealerOptions, onError = _a.onError, onView = _a.onView;
        var cmsElementItems;
        if (loaded) {
            try {
                cmsElementItems = cmsDataStore.cmsElementItems();
            }
            catch (error) {
                if (onError) {
                    this.reportError({
                        error: error,
                    });
                }
                cmsElementItems = [];
            }
        }
        return loaded ? (React.createElement(CmsElements_1.CmsElements, { dealerOptions: dealerOptions, pageSettings: cmsDataStore.pageSettings, cmsElementContext: cmsDataStore.getContext(), cmsElementItems: cmsElementItems, onView: onView, biLogger: cmsDataStore.biLogger, locale: cmsDataStore.getLocale(), onClick: cmsDataStore.getOnClick(), bannerPosition: cmsDataStore.getBannerPosition(), onClose: cmsDataStore.getOnClose(), metasiteId: cmsDataStore.getMetaSiteId(), bannerRoot: cmsDataStore.getBannerRoot(), onError: this.reportError })) : (React.createElement("div", { "data-hook": "dealer-viewer-empty" }));
    };
    return Root;
}(React.Component));
exports.Root = Root;
//# sourceMappingURL=Root.js.map